module.exports = __webpack_public_path__ + "static/media/marshal_white_reed.112266e1.jpg";